/**
 * Bus mínimo de suscriptores (sin payload o con uno): `subscribe` devuelve el
 * unsubscribe y `notify` llama a todos. Auditoría de reutilización 28/09: la
 * misma silueta `Set + for…of + delete` estaba en vault-session (dos veces),
 * ta-chat-store y el engine del workshop.
 *
 *   const bus = createListeners<void>();
 *   useEffect(() => bus.subscribe(fn), []);
 *   bus.notify();
 */
export function createListeners<T = void>() {
  const set = new Set<(value: T) => void>();
  return {
    subscribe(fn: (value: T) => void): () => void {
      set.add(fn);
      return () => {
        set.delete(fn);
      };
    },
    notify(value: T): void {
      for (const fn of set) fn(value);
    },
  };
}
